import React from 'react';
import { X } from 'lucide-react';

const LegalModal = ({ isOpen, onClose }) => {
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 z-50 overflow-y-auto">
      {/* Backdrop */}
      <div 
        className="fixed inset-0 bg-black/80 backdrop-blur-sm transition-opacity"
        onClick={onClose}
      />
      
      {/* Modal */}
      <div className="relative min-h-screen flex items-center justify-center p-4">
        <div className="relative bg-gradient-to-br from-[#1a1014] to-[#0f0a0d] rounded-2xl shadow-2xl max-w-4xl w-full border border-rose-900/30 max-h-[90vh] overflow-y-auto">
          {/* Header */}
          <div className="sticky top-0 bg-[#1a1014]/95 backdrop-blur-sm border-b border-rose-900/20 p-6 flex justify-between items-center">
            <h2 className="text-3xl font-light text-white">
              Mentions <span className="font-script text-rose-200">Légales</span>
            </h2>
            <button
              onClick={onClose}
              className="p-2 rounded-full hover:bg-rose-900/20 transition-colors text-rose-200"
            >
              <X className="w-6 h-6" />
            </button>
          </div>

          {/* Content */}
          <div className="p-6 sm:p-8 space-y-6 text-gray-300">
            {/* Identification */}
            <section>
              <h3 className="text-xl font-semibold text-rose-200 mb-3">1. Identification de l'entreprise</h3>
              <div className="space-y-2 text-sm">
                <p><strong className="text-white">Dénomination sociale :</strong> LadyGo VTC</p>
                <p><strong className="text-white">Forme juridique :</strong> Entreprise individuelle</p>
                <p><strong className="text-white">SIREN :</strong> 801 419 557 00089</p>
                <p><strong className="text-white">Siège social :</strong> Vannes (Morbihan), France</p>
                <p><strong className="text-white">Email :</strong> <a href="mailto:ladygo.vtc@gmail.com" className="text-rose-300 hover:text-rose-200">ladygo.vtc@gmail.com</a></p>
                <p><strong className="text-white">Téléphone :</strong> <a href="tel:+33611709973" className="text-rose-300 hover:text-rose-200">06 11 70 99 73</a></p>
              </div>
            </section>

            {/* Directeur de publication */}
            <section>
              <h3 className="text-xl font-semibold text-rose-200 mb-3">2. Directeur de publication</h3>
              <p className="text-sm">Le directeur de la publication du site est le responsable de l'entreprise LadyGo VTC.</p>
            </section>

            {/* Hébergement */}
            <section>
              <h3 className="text-xl font-semibold text-rose-200 mb-3">3. Hébergement du site</h3>
              <div className="space-y-2 text-sm">
                <p><strong className="text-white">Hébergeur :</strong> Emergent Agent</p>
                <p><strong className="text-white">Site web :</strong> <a href="https://emergent.sh" target="_blank" rel="noopener noreferrer" className="text-rose-300 hover:text-rose-200">https://emergent.sh</a></p>
              </div>
            </section>

            {/* Propriété intellectuelle */}
            <section>
              <h3 className="text-xl font-semibold text-rose-200 mb-3">4. Propriété intellectuelle</h3>
              <p className="text-sm leading-relaxed">
                L'ensemble du contenu de ce site (textes, images, logos, vidéos) est la propriété exclusive de LadyGo VTC, 
                sauf mention contraire. Toute reproduction, distribution, modification, adaptation, retransmission ou publication 
                de ces différents éléments est strictement interdite sans l'accord exprès par écrit de LadyGo VTC.
              </p>
            </section>

            {/* Protection des données */}
            <section>
              <h3 className="text-xl font-semibold text-rose-200 mb-3">5. Protection des données personnelles (RGPD)</h3>
              <div className="space-y-3 text-sm leading-relaxed">
                <p>
                  Conformément au Règlement Général sur la Protection des Données (RGPD) et à la loi Informatique et Libertés, 
                  vous disposez d'un droit d'accès, de rectification, de suppression et d'opposition aux données personnelles vous concernant.
                </p>
                <p>
                  <strong className="text-white">Données collectées :</strong> Les informations collectées via le formulaire de contact 
                  (nom, email, téléphone, détails du trajet) sont uniquement utilisées pour traiter votre demande de devis.
                </p>
                <p>
                  <strong className="text-white">Exercice de vos droits :</strong> Pour exercer vos droits, vous pouvez nous contacter à l'adresse : 
                  <a href="mailto:ladygo.vtc@gmail.com" className="text-rose-300 hover:text-rose-200 ml-1">ladygo.vtc@gmail.com</a>
                </p>
                <p>
                  <strong className="text-white">Conservation des données :</strong> Vos données sont conservées uniquement le temps nécessaire 
                  au traitement de votre demande et ne sont en aucun cas transmises à des tiers.
                </p>
              </div>
            </section>

            {/* Cookies */}
            <section>
              <h3 className="text-xl font-semibold text-rose-200 mb-3">6. Cookies</h3>
              <p className="text-sm leading-relaxed">
                Ce site utilise des cookies essentiels au bon fonctionnement du site. En naviguant sur ce site, 
                vous acceptez l'utilisation de ces cookies. Vous pouvez configurer les paramètres de votre navigateur 
                pour refuser les cookies, mais cela peut affecter certaines fonctionnalités du site.
              </p>
            </section>

            {/* Responsabilité */}
            <section>
              <h3 className="text-xl font-semibold text-rose-200 mb-3">7. Limitation de responsabilité</h3>
              <p className="text-sm leading-relaxed">
                LadyGo VTC s'efforce d'assurer l'exactitude et la mise à jour des informations diffusées sur ce site. 
                Toutefois, LadyGo VTC ne peut garantir l'exactitude, la précision ou l'exhaustivité des informations mises 
                à disposition sur ce site et décline toute responsabilité pour toute imprécision, inexactitude ou omission.
              </p>
            </section>

            {/* Droit applicable */}
            <section>
              <h3 className="text-xl font-semibold text-rose-200 mb-3">8. Droit applicable et juridiction</h3>
              <p className="text-sm leading-relaxed">
                Les présentes mentions légales sont régies par le droit français. En cas de litige et à défaut d'accord amiable, 
                le litige sera porté devant les tribunaux français compétents.
              </p>
            </section>

            {/* Date de mise à jour */}
            <section className="pt-6 border-t border-rose-900/20">
              <p className="text-xs text-gray-500 italic">
                Dernière mise à jour : Juillet 2026
              </p>
            </section>
          </div>

          {/* Footer du modal */}
          <div className="sticky bottom-0 bg-[#1a1014]/95 backdrop-blur-sm border-t border-rose-900/20 p-6">
            <button
              onClick={onClose}
              className="w-full py-3 px-6 bg-rose-200 text-gray-900 rounded-lg font-medium hover:bg-rose-300 transition-colors"
            >
              Fermer
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default LegalModal;
